import { create } from 'zustand';

const useEmailBannerStore = create((set) => ({
  isModalOpen: false,

  openModal: () => set({ isModalOpen: true }),
  closeModal: () => set({ isModalOpen: false })
}));

export default useEmailBannerStore;
